/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { Row, Col, Checkbox } from 'antd';

import { useCreateGameBanner, useUpdateGameBanner } from '@api/hooks';
import { Block, Button } from '@atoms';
import { TextField } from '@molecules';
import MediaField from '@organisms/MediaField';
import { NO_MARGIN_BOTTOM } from '@constants';
import { Form } from '@organisms';

import { FORM_FIELD, INITIAL_VALUES } from './constants';

const GameBannerForm = ({ id, isFetching = false, initialValues: initData }) => {
  const [form] = Form.useForm(FORM_FIELD);
  const [createGameBannerMutation, createQuery] = useCreateGameBanner({});
  const [updateGameBannerMutation, updateQuery] = useUpdateGameBanner({});

  const initialValues = React.useMemo(
    () => ({
      ...form.deserialize(initData?.id ? initData : INITIAL_VALUES),
    }),
    [initData, form],
  );

  const handleSetLive = React.useCallback((e) => form.setFieldsValue({ [FORM_FIELD.LIVE.name]: e.target.checked }), [
    form,
  ]);

  const onFinish = React.useCallback(
    (values) => {
      const body = {
        id,
        values,
        hasBeenCreated: initialValues?.id ? updateQuery.isSuccess : createQuery.isSuccess,
      };
      if (initialValues?.id) updateGameBannerMutation(body);
      else createGameBannerMutation(body);
    },
    [initialValues, id, createGameBannerMutation, updateGameBannerMutation, updateQuery, createQuery],
  );

  const handleCancel = React.useCallback(() => {
    form.resetFields();
  }, [form]);

  return (
    <Form onSerializedFinish={onFinish} initialValues={initialValues} layout="vertical" form={form}>
      <Row gutter={[30, 30]}>
        <Col span={24}>
          <Block spaced>
            <h2>Add a banner</h2>
            <MediaField {...FORM_FIELD.DESKTOP_BANNER} />
            <MediaField {...FORM_FIELD.MOBILE_BANNER} />
            <TextField {...FORM_FIELD.BANNER_URL} />
            <Form.Item valuePropName="checked" {...FORM_FIELD.LIVE}>
              <Checkbox onChange={handleSetLive}>Set Live</Checkbox>
            </Form.Item>
            <Row align="middle" gutter={20}>
              <Col flex="0 0 auto">
                <Button
                  loading={updateQuery.isLoading || createQuery.isLoading}
                  disabled={isFetching}
                  htmlType="submit"
                  type="primary"
                  key="submit"
                >
                  SAVE
                </Button>
              </Col>

              <Col flex="0 0 auto">
                <Button htmlType="button" key="submit" onClick={handleCancel}>
                  RESET
                </Button>
              </Col>
            </Row>
          </Block>
        </Col>
      </Row>
    </Form>
  );
};

GameBannerForm.useForm = () => Form.useForm(FORM_FIELD);

export default GameBannerForm;
